'use strict';

const getPage = (path) => {
    const RE_SEOID = '[1-9][0-9]*';
    const RE_COUNTRY = '[a-zA-Z]{2}';
    const RE_ANY = '[^\/]+';

    const routing = [
        { type: 'HOME', url: '\/' },
        { type: 'SEARCH', url: '\/search' },
        { type: 'LOCATION', url: '\/' + RE_SEOID },
        { type: 'LOCATION', url: '\/' + RE_SEOID + '-' + RE_ANY },
        { type: 'COUNTRY', url: '\/' + RE_COUNTRY },
        { type: 'GEODIV0', url: '\/' + RE_COUNTRY + '\/' + RE_ANY },
        { type: 'GEODIV1', url: '\/' + RE_COUNTRY + '\/' + RE_ANY + '\/' + RE_ANY },
        { type: 'CITY', url: '\/' + RE_ANY + '\/' + RE_COUNTRY + '\/' + RE_ANY },
        { type: 'STATUS', url: '\/status' }
    ];

    for (let i = 0; i < routing.length; i++) {
        const route = routing[i];
        if (true === new RegExp('^' + route.url + '$').test(path)) {
            return route.type;
        }
    }

    return 'OTHER';
};

module.exports = {
    getPage
};
